module.exports = __webpack_public_path__ + "img/tarot-major-arcana-20.96bbb07e.png";